import React, { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetApplicationInformation } from "../../../Redux/Reducers/Shared/ApplicationInformation";
import moment from "moment-timezone";

const ApplicationInfo = (porps) => {
  const {ApplicationInformationId} = useParams();
  console.log(ApplicationInformationId,"AppGuidAppGuidAppGuid");
  
  const [appInfo, setAppInfo] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      FetchDataJson: state.FetchDataJson,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });

  const lang = useSelector((state) => state.languageReducer.Language);

  console.log(
    state.ApplicationInformation,
    "ApplicationInformationddddddddddd"
  );
  const getData = async () => {
    const data = await dispatch(
      GetApplicationInformation({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          ApplicationInformationId,
      })
    );

    if (data.payload) {
      setAppInfo({ ...data.payload });
    }
  };
  useEffect(() => {
    getData();
  }, [ApplicationInformationId]);
  console.log(appInfo, "appInfo");

  return (
    <>
      <div className="form-grid">
        <InputAHSF
          fieldsName="ApplicationNumberInput"
          show={true}
          lang={lang}
          disabled={true}
          value={appInfo?.applicationNumber}
          showValidationMessage={false}
        />
        <InputAHSF
          fieldsName="ApplicationStatusInput"
          show={true}
          lang={lang}
          disabled={true}
          value={lang === "ar" ? appInfo?.statusNameAr : appInfo?.statusNameEn}
        />
        <InputAHSF
          fieldsName="RequestCreationDateInput"
          show={true}
          lang={lang}
          disabled={true}
          value={moment(appInfo?.dateRequestCreated).format(
            "DD/MM/YYYY h:mm a"
          )}
        />
      </div>
    </>
  );
};

export default ApplicationInfo;
